/**
 * `#56` written before 2026-09-26 (in GitLab-mirrored text) is the project's
 * own number; `refs` maps the ones the server resolved to global ids.
 */
export function linkOldRefs(markdown: string, refs: Record<string, number>): string {
  return markdown.replace(/(^|[^0-9A-Za-z&[])#(\d{1,6})\b/g, (whole, lead: string, n: string) => {
    const g = refs[n];
    return g === undefined ? whole : `${lead}[#${g}](/work-item/${g})`;
  });
}
